import React from "react"

import {useWindowSize} from "hooks";

import HomeCurrentGameMode from "components/organisms/Home/HomeCurrentGameMode";
import DeviceCardBlock from "components/organisms/Home/DeviceCardBlock";
import HomeComingSoon from "components/organisms/Home/HomeComingSoon";
import HomeEngine from "components/organisms/Home/HomeEngine";
import HomeSpacs from "components/organisms/Home/HomeSpacs";
import HomeNews from "components/organisms/Home/HomeNews";
import HomeMain from "components/organisms/Home/HomeMain";
import HomeWhy from "components/organisms/Home/HomeWhy";
import DefaultLayout from "layouts/DefaultLayout";
import Seo from "components/atoms/Seo";

const Home = () => {
    const {width} = useWindowSize()

    return (
        <DefaultLayout>
            <Seo
                title="KOMPETE: The Ultimate Gaming Platform"
                description="KOMPETE is a multiplayer gaming platform with multiple games of different genres. Jump seamlessly with your avatar from game to game on the main menu. Play Early Access on PC, Android, and iOS! "
            />
            <HomeMain/>
            <React.Fragment>{width < 991 && <DeviceCardBlock/>}</React.Fragment>
            <HomeCurrentGameMode/>
            <HomeComingSoon/>
            <HomeWhy/>
            <HomeNews/>
            <HomeEngine/>
            <HomeSpacs/>
        </DefaultLayout>
    )
}
export default Home